<template>
  <div class="cart-item travel-order-item">
    <div class="travel-order-item__arrows">
      <button
        class="btn btn--sm btn--primary-inverse btn--icon-only"
        type="button"
        @click="$emit('move', cartItem.id, 'up')"
        :disabled="isFirst"
      >
        <Icon name="arrow-up" />
        <span class="sr-only">{{ i18n.moveItemUp }}</span>
      </button>

      <button
        class="btn btn--sm btn--primary-inverse btn--icon-only"
        type="button"
        @click="$emit('move', cartItem.id, 'down')"
        :disabled="isLast"
      >
        <Icon name="arrow-down" />
        <span class="sr-only">{{ i18n.moveItemDown }}</span>
      </button>
    </div>

    <div class="cart-item__body border p-3 w-100">
      <div class="row align-items-xl-center">
        <div class="col-md-3 travel-order-item__image-column mb-3 mb-md-0">
          <div class="cart-item__image position-relative">
            <div class="cart-item__number">
              {{ index }}
            </div>

            <div class="position-relative overflow-hidden ratio--4-3">
              <img
                :src="cartItem.image"
                alt=""
                class="img-fit absolute-center lazyload"
                loading="lazy"
              >
            </div>
          </div>
        </div>

        <div class="col-md-9 travel-order-item__content-column pl-md-2 d-flex flex-column">
          <button
            class="media-item__remove btn"
            style="top: 0"
            type="button"
            @click="() => removeCartItem(cartItem.id)"
          >
            <Icon name="trash" />
            <span class="sr-only">{{ i18n.remove_item }}</span>
          </button>

          <div class="cart-item__content cart-item__content-width d-flex flex-column flex-grow-1">

            <div class="h3 color-text-dark font-weight-bold">
              {{ cartItem.title }}
            </div>

            <div v-if="false" class="d-flex flex-column flex-md-row mt-1">
              <div class="d-flex align-items-center capped-xxs">
                <div class="font-size-xxs color-text-dark mr-3">
                  <strong>{{ i18n.dateOfArrival }}:</strong> {{ cartItem.dateOfArrival }}
                </div>
              </div>

              <div class="d-flex align-items-center capped-xxs mt-2 mt-md-0 ml-md-4">
                <div class="font-size-xxs color-text-dark mr-3">
                  <strong>{{ i18n.dateOfDeparture }}:</strong> {{ cartItem.dateOfDeparture }}
                </div>
              </div>
            </div>

            <div class="d-flex flex-column flex-xl-row font-size-xxs mt-2">
              <div>
                <Icon name="pin" extra-classes="mt-nudge-4 mr-1" />{{ cartItem.location }}
              </div>

              <div class="mt-1 ml-xl-3 mt-xl-0">
                <Icon name="night" extra-classes="mt-nudge-2 mr-1" />{{ cartItem.amountOfNights }} {{ i18n.nights.toLowerCase() }}
              </div>

              <div class="mt-1 ml-xl-3 mt-xl-0">
                {{ cartItem.amountOfPersonsFormatted }}
              </div>

              <div class="color-primary font-weight-bold mt-3 mt-xl-0 ml-lg-auto">
                {{ price }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="cartItem.error" class="travel-order-item__error">
      <Icon name="exclamation" extra-classes="icon--lg color-negative" />

      <p class="mb-0">{{ cartItem.error }}</p>
    </div>
  </div>
</template>

<script>
import formatPrice from '@/helpers/formatPrice';
import Icon from '@/cart/components/Icon.vue';
import {mapActions} from 'vuex';

export default {
  components: {
    Icon,
  },

  props: {
    cartItem: {
      type: Object,
      required: true,
    },

    index: {
      type: Number,
      required: true,
      default: 1,
    },

    isFirst: {
      type: Boolean,
      required: false,
      default: false,
    },

    isLast: {
      type: Boolean,
      required: false,
      default: false,
    },
  },

  methods: {
    ...mapActions([
      'removeCartItem',
    ]),
  },

  computed: {
    price() {
      const price = formatPrice(this.cartItem.pricePerPerson, 0, '€ ', '');

      return this.i18n.pricePerPerson.replace('%s', price);
    },
  },
};
</script>
